import { useMemo } from 'react'
import { useUserStore } from 'src/feature/user/store/user.store'
import { useOverlayTourTips } from 'src/feature/overlay/component/OverlayTourTips'
import { DefaultSiteMap } from 'src/feature/user/model/SiteMap'
import { useAuthStore } from 'src/feature/auth/store/auth.store'
import { OrganisationRole } from 'src/feature/control-panel/model/OrganisationRole'

export const useTourSteps = () => {
  const { sitemap } = useUserStore()
  const allTourSteps = useOverlayTourTips()
  const authStore = useAuthStore()
  
  // Merge default sitemap with user sitemap for current sitemap
  const effectiveSitemap = {
    modules: [
      ...(DefaultSiteMap.modules || []), // Include DefaultSiteMap modules
      ...(sitemap?.modules || []), // Include sitemap modules
      ...[{ key: 'contactCard' }],
    ],
  }

  // Remove skillGap and projectBuilder if user doesn't have admin roles (only regular User)
  const hasAdminRole = authStore.hasRole(OrganisationRole.SystemAdministrator) || authStore.hasRole(OrganisationRole.UserAdministrator)
  
  if (!hasAdminRole) {
    effectiveSitemap.modules = effectiveSitemap.modules.filter(
      module => module.key !== 'skillGap' && module.key !== 'projectBuilder',
    )
  }

  // Get all available modules
  const availableModules = effectiveSitemap.modules.map(m => m.key)

  // If module exists in sitemap, return its key as className
  const getStepClass = (moduleKey: string) => {
    return availableModules.includes(moduleKey) ? moduleKey : undefined
  }

  // Filter tour steps to only include modules that exist
  const activeTourSteps = useMemo(() => {
    return Object.entries(allTourSteps)
      .filter(([moduleKey]) => availableModules.includes(moduleKey))
      .map(([_, config]) => config)
  }, [availableModules, allTourSteps])

  return {
    getStepClass,
    activeTourSteps,
    availableModules,
  }
}
